import React from "react";
import AdminLayout from "../AdminLayout";
import AdminQuizManager from "./AdminQuizManager";

export default function AdminQuizPage() {
  return (
    <AdminLayout title="Onboarding Quiz Manager">
      <div style={{ padding: 16 }}>
        <AdminQuizManager />
      </div>
    </AdminLayout>
  );
}
